import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductDetailsModule} from './details/product-details.module';
import {ConfiguratorModule} from './configurator/configurator.module';
import {CtaFormModule} from './cta-form/cta-form.module';
import {LeadModule} from '@app/product/lead/lead.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ConfiguratorModule,
    CtaFormModule,
    ProductDetailsModule,
    LeadModule
  ]
})
export class ProductModule {
}
